/**
 * A Coordinate Reference System is a framework used to reference spatial positions.
 * They fall into two types:
 *  - Geographic Coordinate System (GCS): Uses a 3D, spherical surface to define locations using latitude and longitude.
 *  - Projected Coordinate System (PCS): A planar, 2D system that projects the spherical earth onto a flat surface (e.g., UTM).
 *
 * EPSG Codes: These are unique identifiers used to define a specific CRS, such as EPSG:4326 for WGS84 (commonly used in GPS) or EPSG:3857 for Web Mercator.
 */
export const NoraSupportedCoordinateFormats = {
  WEB_MERCATOR: 'EPSG:3857',
  WGS84: 'EPSG:4326',
  UTM: 'UTM',
  MGRS: 'MGRS',
  DMS: 'DMS',
  HDMM: 'HDMM',
} as const;

export type NoraCoordinateFormat = keyof typeof NoraSupportedCoordinateFormats;

export interface NoraPosition {
  latitude: number;
  longitude: number;
}

export type NoraExtent = [number, number, number, number];
